export enum Path {
  Root = '/',
  Login = '/login',
  Register = '/register',
  VerifyEmail = '/verify-email',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password/:token',
  Profile = '/profile',
  QuestionnaireSelection = '/questionnaire',
  Questionnaire = '/questionnaire/:questionnaireId',
  Result = '/result/:id',
  Dashboard = '/dashboard',
  AdminDashboard = '/admin',
  AdminUsers = '/admin/users',
  AdminQuestions = '/admin/questions',
  AdminQuestionModules = '/admin/question-modules',
  AdminQuestionnaires = '/admin/questionnaires',
  AdminAnswerOptionSets = '/admin/answer-option-sets',
  AdminResults = '/admin/results',
  AdminApiLogs = '/admin/api-logs',
  Unauthorized = '/unauthorized',
  Experiment = '/experiment',
  Else = '*',
}
